// eslint-disable-next-line import/no-unresolved
import { apiUrl } from '../../../utils/api';
import { apiBasePath } from '../../BasicUrl';


const storeTimeApi = apiBasePath.injectEndpoints({
    endpoints: (build) => ({
        getStoreOpen: build.mutation({
            query: (data) => ({
                url: `${apiUrl.storeOpen}`,
                method: "POST",
                body: data,
            })
        }),
        getStoreTimeApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.storeTime}`,
                method: "POST",
                body: data,
            })
        }),
        getStoreTimeUpdateApi: build.mutation({
            query: (data) => ({
                url: `${apiUrl.storeTime}`,
                method: "PUT",
                body: data,
            })
        }),


    }),
    overrideExisting: false,
});
export const { useGetStoreOpenMutation, useGetStoreTimeApiMutation, useGetStoreTimeUpdateApiMutation } = storeTimeApi;
